import { Injectable, inject } from '@angular/core'
import { BvAlertService } from '@ziptility/bv-alert'
import { MapAPIService } from '@modules/bv-api'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { AuthorizationService } from '@ziptility/services'
import { EMPTY, of } from 'rxjs'
import { catchError, map, switchMap } from 'rxjs/operators'
import { selectMap } from '../preference/actions'
import * as MapsActions from './actions'

@Injectable()
export class MapsEffects {
  readonly authorizationService = inject(AuthorizationService)
  readonly bvAlertService = inject(BvAlertService)
  readonly actions$ = inject(Actions)
  readonly mapService = inject(MapAPIService)

  fetchMaps$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MapsActions.fetchMaps),
      switchMap(() =>
        this.mapService.list().pipe(
          map((maps) => MapsActions.fetchMapsSuccess({ maps })),
          catchError((error) => of(MapsActions.fetchMapsError({ error }))),
        ),
      ),
    ),
  )

  MapSelected$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MapsActions.selectMap),
      map(({ map: { id } }) => selectMap({ id })),
    ),
  )

  MapUpdateRequest$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MapsActions.mapUpdated),
      switchMap(({ map: bvMap }) =>
        this.mapService.update(bvMap.id, bvMap).pipe(
          map((map) => {
            this.bvAlertService.success(`Map was updated successfully.`)
            return MapsActions.mapUpdatedSuccess({ map })
          }),
        ),
      ),
    ),
  )

  MapRemoveRequest$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MapsActions.mapRemoved),
      switchMap(({ map }) =>
        this.mapService.remove(map.id).pipe(
          switchMap(() => {
            this.bvAlertService.success(`Map was deleted successfully.`)
            return of(MapsActions.mapRemovedSuccess({ map }))
          }),
          catchError((error) => of(MapsActions.mapRemovedError({ error }))),
        ),
      ),
    ),
  )

  MapCreateRequest$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MapsActions.createMap),
      switchMap(({ map }) =>
        this.mapService.create(map).pipe(
          switchMap((map) => {
            this.bvAlertService.success(`Map was created successfully.`)
            return of(MapsActions.createMapSuccess({ map }))
          }),
          catchError(() => EMPTY),
        ),
      ),
    ),
  )
}
